import App from 'Components/region';
import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import fetchJson from 'Utils/fetchJson';
import getLocales from 'Utils/getLocales';
import { getRegionalContent } from 'Utils/getContent';
import { globalTrackerAPIRoot } from 'Constants/locations';

const atlas = new AtlasMetadataClient();

const Page = (props) => {
  return (
    <App {...props} />
  );
};

export default Page;

export const getStaticProps = async({ params }) => {
  const { region } = params;

  // Content
  const content = getRegionalContent('en', region);

  // Statistics
  const globalStatistics = await fetchJson(`${globalTrackerAPIRoot}/statistics.json`);
  const regionalStatistics = await fetchJson(`${globalTrackerAPIRoot}/regions/${region}/statistics.json`);
  const regionalCounts = await fetchJson(`${globalTrackerAPIRoot}/regions/counts/all.json`);

  return ({
    props: {
      ...params,
      content,
      globalStatistics,
      regionalStatistics,
      regionalCounts,
      locale: 'en',
      locales: getLocales(),
    },
  });
};

export const getStaticPaths = async() => {
  const paths = atlas.regions
    .map((region) => ({ params: { region: region.slug } }));

  return { paths, fallback: false };
};
